export default __webpack_public_path__ + "static/media/Project_Line.a756b9b0.svg";